import MainLayout from './layouts/MainLayout.vue';
import Login from './pages/Login.vue';

export default {
  path: '/account',
  component: MainLayout,
  meta: { noNeedAuth: true },
  children: [{
    path: 'login',
    name: 'login',
    component: Login,
    meta: { noNeedAuth: true, layout: 'center-layout' },
  }],
};
